class Tabs extends HTMLElement {
  constructor() {
    super();
    this.handleTabButtonClick = this.handleTabButtonClick.bind(this);
  }

  connectedCallback() {
    this.tabButtonElems = this.querySelectorAll(
      'tab-button, button[data-tab-index]'
    );
    this.tabContentElems = this.querySelectorAll(
      'tab-content, [data-tab-panel]'
    );

    if (!this.tabsIntersectionObserver) {
      this.tabsIntersectionObserver = new IntersectionObserver(entries => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            this.addButtonEventListeners();
          }
        }
      });
    }

    this.tabsIntersectionObserver.observe(this);
  }

  disconnectedCallback() {
    this.tabsIntersectionObserver?.disconnect();
    this.removeButtonEventListeners();
  }

  addButtonEventListeners() {
    if (!this.isConnected) return;

    for (const buttonElement of this.tabButtonElems) {
      buttonElement.removeEventListener('click', this.handleTabButtonClick);
      buttonElement.addEventListener('click', this.handleTabButtonClick);
    }
  }

  removeButtonEventListeners() {
    if (!this.tabButtonElems) return;

    for (const buttonElement of this.tabButtonElems) {
      buttonElement.removeEventListener('click', this.handleTabButtonClick);
    }
  }

  /**
   * @param {Event} event
   */
  handleTabButtonClick(event) {
    const buttonElement = event.currentTarget;

    if (event.target.active) {
      return;
    }

    for (const buttonElement_ of this.tabButtonElems) {
      buttonElement_.removeAttribute('active');
    }

    buttonElement.setAttribute('active', '');

    const selectedTabContent = this.querySelector(
      `tab-content[data-tab-index="${buttonElement.dataset.tabIndex}"], [data-tab-panel="${buttonElement.dataset.tabIndex}"]`
    );

    selectedTabContent.setAttribute('active', '');
    selectedTabContent.setAttribute('aria-hidden', 'false');

    for (const tabContentElement of this.tabContentElems) {
      if (tabContentElement !== selectedTabContent) {
        tabContentElement.removeAttribute('active');
        tabContentElement.setAttribute('aria-hidden', 'true');
      }
    }
  }
}

export default Tabs;
